import React from 'react'
import './Content.css'
import icon1 from '../../assetsS/images/boxicon3.png'
import icon2 from '../../assetsS/images/boxicon2.png'
import icon3 from '../../assetsS/images/boxicon1.png'

export default class TextonImage extends React.Component {
  state = {}

  updateDetails() {
    this.props.handleStateChange(this.state)
  }

  componentWillReceiveProps(newProps) {
    this.setState(newProps)
  }

  componentDidMount = async () => {
    this.setState(this.props)
  }

  render() {
    const isBgImg = this.state.isBgImg

    const cards = [
      {
        icon: icon1,
        number: '01',
        heading: 'Exclusive NEET Testing Practice Progress Tracker',
        body: 'Monitor the students study progress. After each lessons teacher can assign the test practice to students online. Monitor the performance of each and every student and create individualized test plans based on students strength and weakness.',
      },
      {
        icon: icon2,
        number: '02',
        heading: 'Automated NEET Test Assessment',
        body: 'With the help of the AI-Powered Assessments Generator, generate thousands of tests in just clicks. Based on students test results AI-formulates individualized exclusive test practice.',
      },
      {
        icon: icon3,
        number: '03',
        heading: 'Cloud-Based NEET Online Study Tips & Solutions',
        body: 'Enable flexible learning for your students with immersive digital content available anytime, anywhere.',
      },
    ]

    return (
      <div className="content-section">
        <div className="container py-5">
          <div className="row g-4">
            {cards.map((card, i) => (
              <div key={i} className="col-12 col-md-12 col-xl-4">
                <div className="content-card">

                  {/* Top accent bar */}
                  <div className="content-card__bar" />

                  {/* Number watermark */}
                  <span className="content-card__number">{card.number}</span>

                  {/* Icon */}
                  <div className="content-card__icon-wrap">
                    <img src={card.icon} alt="" width={48} height={48} className="content-card__icon" />
                  </div>

                  {/* Heading */}
                  <h3 className="content-card__heading">
                    {card.number}.&nbsp;{card.heading}&nbsp;:
                  </h3>

                  {/* Body */}
                  <p className="content-card__body">{card.body}</p>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}